// extracted by mini-css-extract-plugin
export default {"settingContainer":"Account_settingContainer__J2g1y"};